import {
  prepareReviewVoice,
  speakTextWithAlignment,
  type SpokenAudio,
} from '../../../lib/englishApi.js';
import { openLine } from './reviewCoachLines.js';

/**
 * La voz de la primera línea del coach, pedida ANTES de abrir el repaso (card
 * #595, Emmanuel 21/10: «el coach tarda demasiado en hablar al empezar»). El
 * Inicio la pide cuando dibuja el Repaso del día, y el repaso, apenas se abre,
 * mientras llegan las pistas (antes la pedía recién con las pistas, y junto con
 * otras nueve: medido el 21/10, 6,8 s hasta que sonó). El repaso se la lleva
 * (`takeWarmReviewVoice`) en vez de pedirla otra vez: dos pedidos a la vez
 * generarían y cobrarían la misma voz dos veces.
 *
 * Vence a los 10 minutos: si en el medio cambió de voz o de tono, el repaso la
 * pide de nuevo con la de ahora. Un pedido que falla no queda guardado.
 */
const WARM_MS = 10 * 60_000;

const warm = new Map<string, { at: number; voice: Promise<SpokenAudio> }>();

export function warmReviewVoice(text: string): void {
  const known = warm.get(text);
  if (known && Date.now() - known.at < WARM_MS) return;
  const voice = speakTextWithAlignment(text, { use: 'review' });
  const entry = { at: Date.now(), voice };
  warm.set(text, entry);
  voice.catch((err: unknown) => {
    if (warm.get(text) === entry) warm.delete(text);
    console.warn('[review] coach voice prefetch failed', err);
  });
}

/** La voz pedida de antemano para esta línea (y la saca: es de un solo repaso); `null` = no hay. */
export function takeWarmReviewVoice(text: string): Promise<SpokenAudio> | null {
  const known = warm.get(text);
  warm.delete(text);
  return known && Date.now() - known.at < WARM_MS ? known.voice : null;
}

/**
 * Deja guardadas en el server las dos primeras líneas posibles del repaso (la que arranca
 * mirando y la que vuelve sin mirar) con la voz y el tono de AHORA, sin bajarlas (card #595).
 * Medido el 21/10: con una voz o un tono que nunca se usó, tocar el Repaso del día apenas
 * aparece dejaba ~3 s sin voz. Se llama donde esa combinación puede cambiar o ser nueva: al
 * cerrar una charla con correcciones (de ahí sale el repaso) y al guardar los ajustes de la
 * charla. Si falla, el repaso la pide como siempre.
 */
export function prepareReviewOpenings(): void {
  for (const returning of [false, true]) {
    prepareReviewVoice(openLine(0, returning)).catch((err: unknown) =>
      console.warn('[review] could not prepare the coach voice', err),
    );
  }
}
